export const environment = {
  production: false,
  apiBase: 'https://erpbackendpro.maids.cc',
  newErp: true,
  googleRedirectUri: 'https://erp.maids.cc/external-google-login.html',
  oldPublicPagesRoute: 'https://tmp-erp.maids.cc/',
  stage: 'production',
};
